// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".values--darkness{background-size:cover;background-position:50%;background-repeat:no-repeat}.values__grid{display:grid;grid-template-columns:repeat(3,1fr);grid-gap:64px 16px}@media (max-width:767px){.values__grid{grid-template-columns:1fr}}.values__grid--full{grid-template-columns:repeat(4,1fr)}@media (max-width:991px){.values__grid--full{grid-template-columns:1fr 1fr}}@media (max-width:767px){.values__grid--full{grid-template-columns:1fr}}", ""]);
// Exports
module.exports = exports;
